import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';
import { useLang } from '../context/LanguageContext';
import { CATEGORIES } from '../data/mock';
import { localize } from '../data/mock';

const CONTACT = {
  email: 'audoye@starkke.fr',
  tel: '01 83 64 36 00',
  address: '10 Boulevard Raspail, 75007 Paris',
};

const Footer = () => {
  const { t, lang } = useLang();

  return (
    <footer className="bg-[#1b2331] text-[#f4efe6]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Logo dark />
            <p className="font-serif-display italic text-lg mt-6 text-[#c8a469]">
              {t('footer.tagline')}
            </p>
            <p className="font-sans-elegant text-[0.7rem] tracking-wide-2 mt-6 opacity-60">
              FRANCE · SUISSE · INTERNATIONAL
            </p>
          </div>

          <div>
            <h4 className="font-sans-elegant text-[0.7rem] tracking-brand uppercase text-[#c8a469] mb-6">
              {t('footer.explore')}
            </h4>
            <ul className="space-y-3">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/biens?cat=${c.slug}`}
                    className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors"
                  >
                    {localize(c.label, lang)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-sans-elegant text-[0.7rem] tracking-brand uppercase text-[#c8a469] mb-6">
              {t('footer.expertises')}
            </h4>
            <ul className="space-y-3">
              <li><Link to="/expertises" className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors">{t('expertise.e1t')}</Link></li>
              <li><Link to="/expertises" className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors">{t('expertise.e2t')}</Link></li>
              <li><Link to="/expertises" className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors">{t('expertise.e3t')}</Link></li>
              <li><Link to="/expertises" className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors">{t('expertise.e4t')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans-elegant text-[0.7rem] tracking-brand uppercase text-[#c8a469] mb-6">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#c8a469]" />
                <a href={`mailto:${CONTACT.email}`} className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors">{CONTACT.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#c8a469]" />
                <a href={`tel:${CONTACT.tel.replace(/\s/g, '')}`} className="font-sans-elegant text-sm opacity-70 hover:opacity-100 hover:text-[#c8a469] transition-colors">{CONTACT.tel}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#c8a469]" />
                <span className="font-sans-elegant text-sm opacity-70">{CONTACT.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#c8a469] opacity-0" />
                <span className="font-sans-elegant text-sm opacity-70">{t('contact.hours')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#f4efe6]/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans-elegant text-[0.7rem] tracking-wide-2 opacity-50">
            © {new Date().getFullYear()} STARKKE Immobilier. {t('footer.rights')}
          </p>
          <div className="flex gap-6">
            <span className="font-sans-elegant text-[0.7rem] tracking-wide-2 opacity-50 hover:opacity-100 cursor-pointer transition-opacity">{t('footer.legal')}</span>
            <span className="font-sans-elegant text-[0.7rem] tracking-wide-2 opacity-50 hover:opacity-100 cursor-pointer transition-opacity">{t('footer.privacy')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export const CONTACT_INFO = CONTACT;
export default Footer;
